import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";

const NewFooter = () => {
  const services = [
    "Floor Tiling",
    "Wall Tiling",
    "Bathroom Tiling",
    "Kitchen Tiling",
    "Outdoor Tiling",
    "Commercial Tiling",
  ];

  const quickLinks = [
    { name: "Home", href: "#home" },
    { name: "Services", href: "#services" },
    { name: "About", href: "#about" },
    { name: "Contact", href: "#contact" },
  ];

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* About */}
          <div>
            <h3 className="text-2xl font-bold mb-4">EVERSHINE SERVICES</h3>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Professional tiling services across Brisbane, Gold Coast, and
              Sunshine Coast. Quality workmanship and customer satisfaction
              guaranteed.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index}>
                  <a
                    href="#services"
                    className="text-gray-400 hover:text-blue-400 transition-colors duration-300"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
                <div>
                  <a
                    href="tel:+61434344277"
                    className="text-gray-400 hover:text-blue-400 transition-colors duration-300"
                  >
                    +61 434 344 277
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
                <div>
                  <a
                    href="mailto:info@evershinetiling.com.au"
                    className="text-gray-400 hover:text-blue-400 transition-colors duration-300"
                  >
                    info@evershinetiling.com.au
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-gray-400">
                    Brisbane, Gold Coast
                    <br />& Sunshine Coast
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400">
            &copy; {new Date().getFullYear()} Evershine Services. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default NewFooter;
